<template>
    <div class="main-content" v-cloak>
        <div class="container">
            <div class="error-container">
                <div class="error-header">
                    Oh snap!
                </div>
                <div class="error-icon">
                    <span class="icon icon-error"></span>
                </div>
                <div>
                    <div class="error-msg">Strange things happening ...</div>
                    <div class="error-msg-bottom">
                        We appreciate it very much if you shortly describe us what just happened
                    </div>
                    <custom-textarea
                        error_msg="Error! This field is mandatory"
                        :invalid="errors && errors.includes('description')"
                        :required="true"
                        label="Enter failure's description here"
                        v-model="description"
                    ></custom-textarea>

                    <div class="form-submit">
                        <a @click="send_report" class="btn-default" href="javascript:{}">Send</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Vue from "vue";
import { mapActions, mapState } from "vuex";
import customTextarea from "@/components/pages/custom-textarea.vue";

export default {
    name: "events-error",
    components: {
        customTextarea
    },
    data() {
        return {
            errors: [],
            description: null
        };
    },
    props: ["back_link"],
    mounted() {},
    computed: {},
    methods: {
        ...mapActions(["send_error_report"]),
        send_report() {
            this.errors = [];
            if (!this.description) {
                this.errors.push("description");
            } else {
                this.description = this.description.trim();
                if (!this.description) {
                    this.errors.push("description");
                }
            }
            if (this.errors.length === 0) {
                let data = {
                    description: this.description,
                    back_to_link: this.back_link
                };
                this.send_error_report(data);
            }
        }
    }
};
</script>

<style scoped>
.error-container {
    margin-bottom: 4.2rem;
}
@media (max-width: 82rem) {
    .main-content {
        height: 60vh;
        overflow: auto;
    }
}
</style>
